import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Sientes que tu cuerpo cambió y no sabes cómo explicarlo.', 'Te sientes inflamada, cansada y con muy poca energía durante el día.', 'Duermes mal o te despiertas varias veces en la noche.', 'Te miras al espejo y no te reconoces como antes.', 'Vives en dieta constante y aun así te sientes inflamada y frustrada.'];
export function PainSection() {
  return <section className="bg-warm-white py-16 md:py-24 px-4" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-olive mb-6" data-id="element-202">
            ¿Te está pasando esto después de los 40?
          </h2>
          <p className="text-lg md:text-xl text-warm-gray italic" data-id="element-203">
            "¿Sientes que comes mejor, haces esfuerzo... y aun así tu abdomen
            sigue inflamado?"
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-204">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-card" data-id="element-205">
              <div className="mt-1.5 w-3 h-3 rounded-full bg-warm-accent flex-shrink-0" data-id="element-206" />
              <p className="text-olive font-medium text-lg" data-id="element-207">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center space-y-2 bg-cream p-8 rounded-2xl border border-sage/20" data-id="element-208">
          <p className="text-xl md:text-2xl font-bold text-olive font-heading" data-id="element-209">
            No es falta de fuerza de voluntad.
          </p>
          <p className="text-lg md:text-xl font-bold text-sage" data-id="element-210">
            Son cambios hormonales reales que casi nadie te explicó.
          </p>
        </motion.div>
      </div>
    </section>;
}